<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
          <img class="user_img" src="../../assets/gameknight/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
          <h1 class="mobiTitle md">{{$t("hello")}}!</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_Gkn}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_Gkn}}</h2>
            </div>  
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_Gkn}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="authentication_Gkn === 'loggedin'">
            <div v-if="is_unsub_Gkn != '0'">
              <a @click="logout_Gkn(is_unsub_Gkn)" href="" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
            <div v-else>
              <a @click="logout_Gkn(is_unsub_Gkn)"  href="/logout" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_Gkn",
    "renew_date_Gkn",
    "subscription_date_Gkn",
    "authentication_Gkn",
    "is_unsub_Gkn"
  ]),
  methods: {
    ...mapActions(["logout_Gkn"])
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #fff;
  }
  margin-top: 15px;
}
.inputWrap__label {
  color: grey;
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gameknight/Profile.vue